import initBlogGAEvents from '@PROJECT_ROOT/assets/shared/js/blog/googleAnalytics';
import initBlogSearch from '@PROJECT_ROOT/assets/shared/js/blog/search';

export default function initBlogMenu(state) {
    redirectOnCategoryMenuChange();
    fixCategoryMenuToTop();
    initBlogGAEvents();
    initBlogSearch(state);
}

// Promjena kategorije u padajućem izborniku aktivira odlazak na stranicu te kategorije
function redirectOnCategoryMenuChange() {
    document.getElementById('blogMenuSelect').addEventListener('change', (event) => {
        window.location.href = event.currentTarget.value;
    });
}

// Fiksiranje menija kategorija na vrh
function fixCategoryMenuToTop() {
    const blogMenu = document.getElementById('floatingHeaderBlog');
    window.addEventListener('scroll', () => {
        if (window.pageYOffset > 40) {
            blogMenu.classList.add('fixedTop');
        } else {
            blogMenu.classList.remove('fixedTop');
        }
    });
}
